/**
 * Vine Program 费用常量 (2024-2025)
 * 数据来源: Amazon官方文档,更新日期: 2024-12
 */

// Vine 费用层级类型
export interface VineFeeTier {
    minUnits: number;
    maxUnits: number;
    fee: number;
}

// Vine 费用配置
export const VINE_FEES: Record<string, VineFeeTier[]> = {
    US: [
        { minUnits: 1, maxUnits: 2, fee: 0 },
        { minUnits: 3, maxUnits: 10, fee: 75 },
        { minUnits: 11, maxUnits: 30, fee: 200 },
    ],
    UK: [
        { minUnits: 1, maxUnits: 10, fee: 60 },
        { minUnits: 11, maxUnits: 30, fee: 140 },
    ],
    DE: [
        { minUnits: 1, maxUnits: 2, fee: 0 },
        { minUnits: 3, maxUnits: 10, fee: 70 },
        { minUnits: 11, maxUnits: 30, fee: 185 },
    ],
    FR: [
        { minUnits: 1, maxUnits: 2, fee: 0 },
        { minUnits: 3, maxUnits: 10, fee: 70 },
        { minUnits: 11, maxUnits: 30, fee: 185 },
    ],
    IT: [
        { minUnits: 1, maxUnits: 2, fee: 0 },
        { minUnits: 3, maxUnits: 10, fee: 70 },
        { minUnits: 11, maxUnits: 30, fee: 185 },
    ],
    ES: [
        { minUnits: 1, maxUnits: 2, fee: 0 },
        { minUnits: 3, maxUnits: 10, fee: 70 },
        { minUnits: 11, maxUnits: 30, fee: 185 },
    ],
    JP: [
        { minUnits: 1, maxUnits: 2, fee: 0 },
        { minUnits: 3, maxUnits: 10, fee: 11250 },
        { minUnits: 11, maxUnits: 30, fee: 30000 },
    ],
    CA: [
        { minUnits: 1, maxUnits: 2, fee: 0 },
        { minUnits: 3, maxUnits: 10, fee: 95 },
        { minUnits: 11, maxUnits: 30, fee: 255 },
    ],
};

export type VineMarketplace = keyof typeof VINE_FEES;

/**
 * 计算 Vine 报名费
 */
export const calculateVineEnrollmentFee = (
    marketplace: VineMarketplace,
    units: number
): number => {
    if (units <= 0 || units > 30) {
        return 0;
    }

    const tiers = VINE_FEES[marketplace];
    const tier = tiers.find(t => units >= t.minUnits && units <= t.maxUnits);

    return tier ? tier.fee : 0;
};

/**
 * 获取 Vine 费用提示文本
 */
export const getVineFeeTip = (marketplace: VineMarketplace, units: number): string => {
    const fee = calculateVineEnrollmentFee(marketplace, units);
    const tiers = VINE_FEES[marketplace];
    const tier = tiers.find(t => units >= t.minUnits && units <= t.maxUnits);

    if (!tier) {
        return '单位数必须在1-30之间';
    }

    const currency = marketplace === 'UK' ? '£' : marketplace === 'JP' ? '¥' : ['DE', 'FR', 'IT', 'ES'].includes(marketplace) ? '€' : '$';
    return `${tier.minUnits}-${tier.maxUnits} 单位: ${currency}${fee}`;
};
